import { Box, TextNew } from '@jfs/ui-new'
import NativeBreadcrumb from '../../../../comps/NativeBreadCrumb'
import { staticStrings } from '../../../../data/static/strings'
import { Routes } from '../../../../nav/routes'
import { styles } from './styles'

const breadCrumbConstants = (isEditing: boolean) => [
  { to: Routes.SETTINGS, label: staticStrings.userManagement, params: { params: staticStrings.userManagement } },
  { label: isEditing ? staticStrings.editPrevUser : staticStrings.addNewuser },
]

interface HeaderInterface {
  hide: boolean
  navigation: any
  isEditing: boolean
}

const Header = ({ hide, navigation, isEditing }: HeaderInterface) => {
  if (hide) {
    return null
  }
  return (
    <>
      <NativeBreadcrumb navigate={navigation.navigate} crumbs={breadCrumbConstants(isEditing)} />
      <Box {...styles.headingContainer} testID={'page-title'}>
        <TextNew {...styles.heading}>{isEditing ? staticStrings.editUserData : staticStrings.addNewUserData}</TextNew>
      </Box>
    </>
  )
}

export { Header }
